import { animate, state, style, transition, trigger } from '@angular/animations';

export class Page<T> {
  items?: T[];
  pageNo?: number;
  pageSize?: number;
  totalCount?: number;
}

export class SecurityDepositPage<T> {
  itemsCount?: number;
  totalItemsCount?: number;
  items?: T[];
}

export class SecurityDepositTableQuery<T> {
  pageSize?: number;
  pageNo?: number;
  sortBy?: T;
  sortDesc?: boolean;
}

export class Policies {
  static readonly AUTHENTICATE = 'authenticate';
  static readonly INVITES = 'invites';
  static readonly APPLICATIONS = 'applications';
  static readonly TENANTS = 'tenants';
  static readonly CLAIMS = 'claims';
  static readonly PROPERTIES = 'properties';
  static readonly FINANCES = 'finances';
  static readonly MANAGERS = 'managers';
  static readonly TECH = 'tech';
  static readonly RANKINGS = 'rankings';
}

export class Claims {
  static readonly INVITES = 'security-deposit-invites';
  static readonly APPLICATIONS = 'security-deposit-pm-applications';
  static readonly TENANTS = 'security-deposit-pm-tenants';
  static readonly CLAIMS = 'security-deposit-pm-claims';
  static readonly PROPERTIES = 'security-deposit-pm-properties';
  static readonly FINANCES = 'security-deposit-pm-finances';
  static readonly MANAGERS = 'security-deposit-pm-managers';
  static readonly TECH = 'security-deposit-tech';
  static readonly RANKINGS = 'security-deposit-pm-utilization-rankings';
}

export const DEFAULT_CSV_PAGE_NUMBER = 1;
export const DEFAULT_CSV_PAGE_SIZE = 10000;

export class ValidationRules {
  public static readonly PASSWORD_REGEX = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,}$';
  public static readonly ONLY_LATIN_LETTERS_WITH_ALLOWED_SYMBOLS = '^[a-zA-Z \'\-]+$';
  public static readonly LATIN_LETTERS_WITH_DIGITS_AND_ALLOWED_SYMBOLS = '^[a-zA-Z0-9 \'\-]+$';

  public static readonly PASSWORD_HINT =
    'Password must contain at least 8 characters, ' +
    'at least one non-alphanumeric character, ' +
    'at least one lowercase (\'a\'-\'z\'), ' +
    'at least one uppercase (\'A\'-\'Z\'), ' +
    'at least one digit (\'0\'-\'9\').';
}

export class ChangePassword {
  username?: string;
  oldPassword?: string;
  newPassword?: string;
}

export const sdTableDetailExpand = trigger(
  'sdTableDetailExpand', [
  state('collapsed', style({ height: '0px', minHeight: '0' })),
  state('expanded', style({ height: '*' })),
  transition(
    'expanded <=> collapsed',
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
  )
]
)

export class FileModel {
  name?: string;
  url?: string;
  typeCode?: number;
  editBlocked?: boolean;

  static isImage(fileName: string) {
    const imageExtensions = ['png', 'gif', 'jpg', 'jpeg', 'bmp'];
    return imageExtensions.some(x => x === fileName.split('.').pop()?.toLowerCase());
  }

  static isPdf(fileName: string) {
    return fileName?.split('.').pop()?.startsWith('pdf');
  }

  static isBase64(url: string): boolean {
    const marker = 'base64,';
    if (!url.includes(marker)) {
      return false;
    }
    const base64String = url.substring(url.indexOf(marker) + marker.length);
    return RegExp('^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$').test(base64String);
  }

  static openBase64FilePdf(file: FileModel) {
    let { url: encodedBuffer } = file;
    encodedBuffer = encodedBuffer?.split(',').pop() as string;
    const buffer = window.atob(encodedBuffer);
    const dataArray = new Uint8Array(buffer.length);

    for (let i = 0; i < dataArray.length; i++) {
      dataArray[i] = buffer.charCodeAt(i);
    }

    const pdfBlob = new Blob([dataArray], { type: 'application/pdf' });
    const pdfBlobUrl = URL.createObjectURL(pdfBlob);

    window.open(pdfBlobUrl);
  }
}
